var $b6c57fa0cd7a21d2$exports = {};
$b6c57fa0cd7a21d2$exports = {
    "maximum": `\u{6700}\u{5927}`,
    "minimum": `\u{6700}\u{5C0F}`
};


export {$b6c57fa0cd7a21d2$exports as default};
//# sourceMappingURL=ja-JP.module.js.map
